import classes from '../../styles/AboutUs.module.scss'
import CustomizedModal from './CustomizedModal'

interface Props {
  open: boolean
  handleClose: (v: boolean) => void
}

export default function AboutUs({ open, handleClose }: Props) {
  return (
    <CustomizedModal
      open={open}
      footer={
        <div className="flex justify-end">
          <button
            onClick={() => handleClose(false)}
            type="button"
            className="mt-2 text-[18px] font-semibold text-center inline-block px-6 py-2.5 bg-green-600 text-white text-xs leading-tight uppercase rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out">
            <div className="flex items-center content-center justify-center text-[16px] font-bold font-arial">
              <span>Close</span>
            </div>
          </button>
        </div>
      }
      onCancel={() => handleClose(false)}>
     <div className={classes.about}>
  <h3>About Us</h3>
  <p>
    Welcome to driversjobchoice.com — your trusted resource for connecting CDL drivers with job opportunities across the United States. We are committed to providing a better way for drivers to find work, offering a clean, simple, and intuitive platform built with your experience in mind.
  </p>
  <p>
    Drivers Job Choice LLC was founded in 2021 by a group of industry professionals with more than 40 years of combined experience in driver recruiting. Our team understands the unique challenges drivers face when searching for the right position — whether it&apos;s OTR, regional, or local — and we’ve used that knowledge to create a platform designed to make your job search easier and more effective.
  </p>
  <p>
    Since our launch, we’ve proudly helped drivers from all over the country connect with reputable carriers offering real, reliable opportunities. At the same time, we work closely with America’s top trucking companies who trust us to deliver quality candidates and consistent support.
  </p>
  <p>
    Whether you&apos;re a seasoned driver looking for your next opportunity or just getting started with your CDL, we’re here to help. Our goal is to provide a job-search experience that respects your time, puts your needs first, and helps you make informed career choices without the usual runaround.
  </p>
  <p>
    We hope you enjoy using Drivers Job Choice as much as we’ve enjoyed building it. If you have questions, feedback, or need assistance, please don’t hesitate to reach out to us.
  </p>
  <p>
    You can contact us at <a href="mailto:info@driversjobchoice.com">info@driversjobchoice.com</a>.
  </p>
  <p className={classes.thankYou}>Thank you for choosing Drivers Job Choice.</p>
</div>


    </CustomizedModal>
  )
}
